import { type GridCellProps } from '@progress/kendo-react-grid'
import React from 'react'

import { HStack } from '~/components/elements/HStack'

import { type BrandAccountUser } from '../hooks'

import { DeleteButton } from './DeleteButton'
import { EditButton } from './EditButton'

export type CommandsCellProps = Omit<GridCellProps, 'dataItem'> & {
  dataItem: BrandAccountUser
}

export const CommandsCell = ({ dataItem }: CommandsCellProps) => {
  const canEdit = React.useMemo(() => dataItem.canEdit, [dataItem.canEdit])
  const canDelete = React.useMemo(
    () => dataItem.canDelete,
    [dataItem.canDelete],
  )

  return (
    <td>
      <HStack
        backgroundColor="transparent"
        justifySelf={canEdit ? 'start' : 'end'}
        spacing={1}
      >
        {canEdit && <EditButton dataItem={dataItem} />}

        {canDelete && <DeleteButton dataItem={dataItem} />}
      </HStack>
    </td>
  )
}
